import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Tooltip } from '../types';

@Component({
  selector: 'app-overview-tooltip',
  imports: [
    CommonModule
  ],
  templateUrl: './overview-tooltip.component.html',
  styleUrl: './overview-tooltip.component.scss'
})
export class OverviewTooltipComponent {
  @Input() data: Tooltip[] = [];
}
